import { createContext, useContext, useEffect, useState } from "react";
import React from "react";

// eslint-disable-next-line @typescript-eslint/no-empty-function
const LocaleContext = createContext({ locale: "es", setLocale: () => {} });

// eslint-disable-next-line react/prop-types
export function LocaleProvider({ children }) {
  const [locale, setLocale] = useState("es");

  useEffect(() => {
    const saved = localStorage.getItem("preferredLocale");
    if (saved) setLocale(saved);
  }, []);

  const change = (l) => {
    setLocale(l);
    localStorage.setItem("preferredLocale", l);
  };

  return (
    <LocaleContext.Provider value={{ locale, setLocale: change }}>
      {children}
    </LocaleContext.Provider>
  );
}

export const useLocale = () => useContext(LocaleContext);
